import { render, staticRenderFns } from "./OverviewPreviousRounds.vue?vue&type=template&id=194bcdb0&"
import script from "./OverviewPreviousRounds.vue?vue&type=script&lang=js&"
export * from "./OverviewPreviousRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports